import { DrawerHeaderStyleConfig } from '../types';

export const styleConfig: DrawerHeaderStyleConfig = {
  baseStyle: {
    borderBottom: 'px',
    borderColor: 'gray.100',
  },
};
